import React, { useState, useEffect } from "react";
import { PageLoader } from "@vionixasia/shared-components";


import { Hero, EventCard } from "../sections/SectionHero";

const isPublicEvent = (event) =>
  event?.hidden !== true && event?.showOnHomepage !== false;

const LandingPage = () => {
  const [events, setEvents] = useState(() => {
    try {
      const cached = localStorage.getItem("cached_landing_events");
      return cached ? JSON.parse(cached).filter(isPublicEvent) : [];
    } catch {
      return [];
    }
  });
  const [dataSource, setDataSource] = useState(() => {
     return localStorage.getItem("cached_landing_events") ? "CACHE" : "INITIAL";
  });
  const [loading, setLoading] = useState(!events.length);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const response = await fetch(`${import.meta.env.VITE_API_BASE_URL}/api/timing/event_timing`);
        if (!response.ok) {
          throw new Error("Failed to fetch events");
        }
        const data = (await response.json()).filter(isPublicEvent);
        // Sort events: ongoing first, then newest by date.
        //
        // The event's own `date` is the source of truth. Reading
        // categories[0].startTime instead put buzzer-timed events — which have
        // no category start at all — at epoch 0 and buried them at the bottom,
        // and it also followed the category clock when the two disagree.
        const eventMs = (event) => {
            const candidates = [event?.date, event?.categories?.[0]?.startTime];
            for (const candidate of candidates) {
                if (!candidate) continue;
                const ms = new Date(
                    candidate?.toDate ? candidate.toDate() : candidate,
                ).getTime();
                if (Number.isFinite(ms)) return ms;
            }
            return 0;
        };
        const sortedEvents = [...data].sort((a, b) => {
            if (a.status === "ongoing" && b.status !== "ongoing") return -1;
            if (a.status !== "ongoing" && b.status === "ongoing") return 1;
            return eventMs(b) - eventMs(a);
        });
        const newEventsString = JSON.stringify(sortedEvents);
        const cachedEventsString = localStorage.getItem("cached_landing_events");

        if (newEventsString !== cachedEventsString) {
            setEvents(sortedEvents);
            setDataSource("API");
            localStorage.setItem("cached_landing_events", newEventsString);
        } else {
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchEvents();
  }, []);

  if (loading) {
    return <PageLoader />;
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-red-500 text-xl font-semibold">Error: {error}</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white flex flex-col">
      {/* Hero Section - Full Width */}
      <Hero events={events} />
      
      {/* Content Section */}
      <div id="events" className="container mx-auto px-4 py-12 scroll-mt-16">
        <div className="flex flex-col gap-4">
          {events.map((event) => (
            <EventCard
              key={event.eventId}
              {...event}
              eventId={event.slug || event.eventId}
              dataSource={dataSource}
            />
          ))}
        </div>

        {events.length === 0 && (
            <div className="text-center py-20">
                <p className="text-gray-500 text-lg">No events found.</p>
            </div>
        )}
      </div>
    </div>
  );
};

export default LandingPage;
